import { Pivot, PivotItem, Stack } from "@fluentui/react";
import React from "react";

import { useCloudFileAssociationSection } from "../context/useCloudFileAssociationSection";
import { CloudFileAssociationContentForm } from "../forms/content/CloudFileAssociationContentForm";
import { CloudFileAssociationLanguageForm } from "../forms/languages/CloudFileAssociationLanguageForm";
import { CloudFileAssociationVideoTechnicalDetailsForm } from "../forms/technical-details/CloudFileAssociationVideoTechnicalDetailsForm";
import { CloudFileAssociationTab } from "./CloudFileAssociationTab";

export const CloudFileAssociationVideoTabs = (): JSX.Element => {
    const { currentTab, setCurrentTab } = useCloudFileAssociationSection();

    return (
        <Pivot selectedKey={String(currentTab)} onLinkClick={(i) => setCurrentTab(Number(i?.props.itemKey))}>
            <PivotItem
                itemKey={CloudFileAssociationTab.Associate.toString()}
                headerText="Associate"
                alwaysRender={true}
                headerButtonProps={{
                    "data-testid": "associate-content-tab-button"
                }}
            >
                <Stack styles={{ root: { padding: 10 } }}>
                    <CloudFileAssociationContentForm />
                </Stack>
            </PivotItem>

            <PivotItem
                itemKey={CloudFileAssociationTab.Languages.toString()}
                headerText="Languages"
                alwaysRender={true}
                headerButtonProps={{
                    "data-testid": "associate-languages-tab-button"
                }}
            >
                <Stack styles={{ root: { padding: 10 } }}>
                    <CloudFileAssociationLanguageForm />
                </Stack>
            </PivotItem>

            <PivotItem
                itemKey={CloudFileAssociationTab.TechnicalInfo.toString()}
                headerText="Technical info"
                alwaysRender={true}
                headerButtonProps={{
                    "data-testid": "associate-technical-info-tab-button"
                }}
            >
                <Stack styles={{ root: { padding: 10 } }}>
                    <CloudFileAssociationVideoTechnicalDetailsForm />
                </Stack>
            </PivotItem>
        </Pivot>
    );
};
